import { render, staticRenderFns } from "./pendingPayment.vue?vue&type=template&id=1ca6c4ee&scoped=true"
import script from "./pendingPayment.vue?vue&type=script&lang=js"
export * from "./pendingPayment.vue?vue&type=script&lang=js"
import style0 from "./pendingPayment.vue?vue&type=style&index=0&id=1ca6c4ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca6c4ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ca6c4ee')) {
      api.createRecord('1ca6c4ee', component.options)
    } else {
      api.reload('1ca6c4ee', component.options)
    }
    module.hot.accept("./pendingPayment.vue?vue&type=template&id=1ca6c4ee&scoped=true", function () {
      api.rerender('1ca6c4ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/servicecenter/pendingPayment.vue"
export default component.exports